import { instance } from './instance'

export const superAdminService = {
  getRestaurants() {
    return instance.get('/restaurants')
  },

  getAllRestaurants() {
    return instance.get('/restaurants')
  },

  getRestaurant(id) {
    return instance.get(`/restaurants/${id}`)
  },

  getRestaurantById(id) {
    return instance.get(`/restaurants/${id}`)
  },

  createRestaurant(data) {
    return instance.post('/restaurants', data)
  },

  updateRestaurant(id, data) {
    return instance.put(`/restaurants/${id}`, data)
  },

  deleteRestaurant(id) {
    return instance.delete(`/restaurants/${id}`)
  },

  toggleRestaurantStatus(id, isActive) {
    return instance.put(`/restaurants/${id}/status`, { isActive })
  },

  getDashboardStats() {
    return instance.get('/SuperAdmin/dashboard/stats')
  },
} 